import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getChallenges } from '@services/challenge.service';
import { IChallenge } from '@interfaces/challenge';

export const fetchListChallenges = createAsyncThunk(
	'challenge/fetchChallengesByMerchantId',
	async ({ merchantId, countryCode }: { merchantId: string; countryCode: string }) => {
		return await getChallenges(merchantId, countryCode);
	},
);

export interface ChallengeState {
	challenges: IChallenge[];
	isLoading: boolean;
	isRefreshing: boolean;
}

const initialState = {
	challenges: [],
	isLoading: true,
	isRefreshing: false,
} satisfies ChallengeState as ChallengeState;

const challengeSlice = createSlice({
	name: 'challenges',
	initialState,
	reducers: {
		setRefreshing: (state, action: PayloadAction<boolean>) => {
			state.isRefreshing = action.payload;
		},
	},
	extraReducers(builder) {
		builder.addCase(fetchListChallenges.pending, (state: ChallengeState) => {
			if (state.challenges.length === 0) {
				state.isLoading = true;
			}
		});
		builder.addCase(fetchListChallenges.fulfilled, (state: ChallengeState, action) => {
			state.isLoading = false;
			state.isRefreshing = false;
			state.challenges = action.payload?.data?.challenges ?? [];
		});
		builder.addCase(fetchListChallenges.rejected, (state: ChallengeState) => {
			state.isLoading = false;
			state.isRefreshing = false;
		});
	},
});

export const challengeReducer = challengeSlice.reducer;
export const { setRefreshing } = challengeSlice.actions;
export default challengeSlice;
